module.exports = __webpack_public_path__ + "static/media/about img1.5716f285.png";